<template>
  <div class="production-section-group mb-4">
    <!-- Título da Categoria em Azul -->
    <h5 class="section-title mb-3">{{ title }}</h5>

    <!-- Card Principal de Produção/Item -->
    <ProductionCard
      :title="cardTitle || title"
      :subtitle="cardSubtitle"
      :value="value"
      :icon="icon"
      :has-upload-invoice="hasUploadInvoice"
      :info-text="infoText"
      @generate-statement="$emit('generate-statement')"
      @upload-invoice="$emit('upload-invoice')"
    />

    <!-- Linha com Subcards (BACKBEAT e GLOSAS) se aplicável -->
    <div v-if="showSummaryCards" class="subcards-row mt-2">
      <SummaryCard
        title="BACKBEAT"
        :value="backbeatValue"
        icon="icon-backbeat"
        :is-external-link="true"
        @click="$emit('open-backbeat')"
      />
      <SummaryCard
        title="GLOSAS"
        :value="glosasValue"
        icon="icon-glosas"
        :is-external-link="true"
        @click="$emit('open-glosas')"
      />
    </div>
  </div>
</template>

<script>
import ProductionCard from "./ProductionCard.vue";
import SummaryCard from "./SummaryCard.vue";

export default {
  name: "ProductionSectionGroup",
  components: {
    ProductionCard,
    SummaryCard,
  },
  props: {
    title: { type: String, required: true },
    cardTitle: { type: String, default: "" },
    cardSubtitle: { type: String, default: "" },
    value: { type: String, required: true },
    icon: { type: String, default: "icon-producao-medica" },
    hasUploadInvoice: { type: Boolean, default: true },
    infoText: { type: String, default: "" },
    showSummaryCards: { type: Boolean, default: true },
    backbeatValue: { type: String, default: "0,00" },
    glosasValue: { type: String, default: "0,00" },
  },
};
</script>

<style lang="scss" scoped>
.production-section-group {
  .section-title {
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    color: #007bff; /* Azul do título das seções conforme layout */
    margin: 0;
  }

  .subcards-row {
    display: flex;
    flex-direction: row;
    gap: 12px;
    width: 100%;

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }
}
</style>